import { createApp } from 'vue'
import Contact from './contact.vue'
import i18n from "../locales";

createApp(Contact)
  .use(i18n())
  .mount('#contact-form')
